import { useRemoveCartItems } from '@/features/cart/hooks/useRemoveCartItems'
import { useUpdateCart } from '@/features/cart/hooks/useUpdateCart'
import { Link } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'
import { BasketLineRemoveButtonProps } from './types'

export const RemoveButton = ({ lineItemKeys }: BasketLineRemoveButtonProps) => {
  const { t } = useTranslation()
  const removeItems = useRemoveCartItems()
  const update = useUpdateCart()

  return (
    <Link
      as="button"
      variant="body-sm"
      className="underline"
      type="button"
      onClick={() =>
        removeItems.mutate(
          lineItemKeys.flatMap((key) => (Array.isArray(key) ? [...key] : key)),
        )
      }
    >
      {t('action.remove')}
    </Link>
  )
}
